import {AfterViewInit, Component} from '@angular/core';
import {Router, NavigationEnd} from "@angular/router";
import { PageType } from 'src/app/model/common.enum';

@Component({
  selector: 'rch-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements AfterViewInit {
  focusElem: HTMLElement | undefined;
  skipToContent: HTMLElement | undefined;
  headerContainer: HTMLElement | undefined;
  showLanguageToggle: boolean = false;

  constructor(
      private router: Router
  ) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.showLanguageToggle = (
            val.url?.indexOf(PageType.ACTIVATE) !== -1 || val.url?.indexOf(PageType.ACCOUNT_SELECTION) !== -1
        );
      }
    });
  }


  ngAfterViewInit() {
    this.focusElem = document.getElementsByTagName("h1") as unknown as HTMLElement;
    this.skipToContent = document.getElementById("skipToContent");
    this.headerContainer = document.getElementById("appBasedTvHeader");
  }

  skipToMainContent(){
    if (this.focusElem && this.skipToContent && this.headerContainer) {
      this.focusElem[0].focus();
      this.skipToContent.className = "btn-skip";
      this.headerContainer.className = "appbased-tv__header"
    }
  }
}
